import { Stack, Typography } from '@mui/material'
import type { AdminModel } from 'higgins-domain'

import { MaterialSwatchSelector, TextValueInput } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

export const WoodTextureSidebar = (props: {
  id: AdminModel.CabinetMaterial['id'] | AdminModel.CountertopMaterial['id']
}) => {
  const { id } = props

  return (
    <Stack gap={3}>
      <PropertyContainer.Group spacing="large">
        <PropertyContainer.Item title="Details">
          <Stack gap={2} sx={{ mt: 2 }}>
            <Stack gap={1}>
              <Typography variant="caption">Wood Texture</Typography>
              <TextValueInput entityId={id} instanceName="name" label="Name" />
              <MaterialSwatchSelector entityId={id} instanceName="woodTexture" />
            </Stack>
          </Stack>
        </PropertyContainer.Item>
      </PropertyContainer.Group>
    </Stack>
  )
}
